export const roles = {
  ADMIN: 'ADMIN',
  ADMIN_DISTRIBUTOR: 'ADMIN_DISTRIBUTOR',
  ADMIN_COMPANY: 'ADMIN_COMPANY',
  END_COMPANY: 'END_COMPANY',
  VIEWER: 'VIEWER',
};

// TODO: move these functions to authService
export const isAdmin = (role: string) => role === roles.ADMIN;
export const isAdminDistributor = (role: string) => role === roles.ADMIN_DISTRIBUTOR;
export const isAdminCompany = (role: string) => role === roles.ADMIN_COMPANY;
export const isEndCompany = (role: string) => role === roles.END_COMPANY;
export const isViewer = (role: string) => role === roles.VIEWER;
